<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('请输入会员帐号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.proxyName' :placeholder="$t('请输入代理帐号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.ip' :placeholder="$t('请输入IP地址') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.orderTime' clearable
                                                      :placeholder="$t('按时间排序') " style='width:120px'>
              <Option :value="'0'">{{ $t('按最新注册时间') }}</Option>
              <Option :value="'1'">{{ $t('按最后登陆时间') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.orderMoney' clearable
                                                      :placeholder="$t('按余额排序') " style='width:120px'>
              <Option :value="'0'">{{ $t('从低到高') }}</Option>
              <Option :value="'1'">{{ $t('从高到低') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.level' clearable :placeholder="$t('按层级搜索') "
                                                      style='width:120px'>
              <Option :value="'1'">{{ $t('第一层') }}</Option>
              <Option :value="'2'">{{ $t('第二层') }}</Option>
              <Option :value="'3'">{{ $t('第三层') }}</Option>
              <Option :value="'4'">{{ $t('第四层') }}</Option>
              <Option :value="'5'">{{ $t('第五层') }}</Option>
              <Option :value="'6'">{{ $t('第六层') }}</Option>
              <Option :value="'7'">{{ $t('第七层') }}</Option>
              <Option :value="'8'">{{ $t('第八层') }}</Option>
              <Option :value="'9'">{{ $t('第九层') }}</Option>
              <Option :value="'0'">{{ $t('黑名单层') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.is_lock' clearable :placeholder="$t('帐号状态') "
                                                      style='width:120px'>
              <Option :value="'0'">{{ $t('正常') }}</Option>
              <Option :value="'1'">{{ $t('锁定') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.userType' clearable :placeholder="$t('帐号类型') "
                                                      style='width:120px'>
              <Option :value="'0'">{{ $t('本站玩家') }}</Option>
              <Option :value="'1'">{{ $t('代理玩家') }}</Option>
              <Option :value="'2'">{{ $t('测试帐号') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.howTimeNoUse' clearable
                                                      :placeholder="$t('连续几天未操作') " style='width:120px'>
              <Option :value="'2'">{{ $t('连续2天未操作') }}</Option>
              <Option :value="'3'">{{ $t('连续3天未操作') }}</Option>
              <Option :value="'4'">{{ $t('连续4天未操作') }}</Option>
              <Option :value="'5'">{{ $t('连续5天未操作') }}</Option>
              <Option :value="'6'">{{ $t('连续6天未操作') }}</Option>
              <Option :value="'7'">{{ $t('连续7天未操作') }}</Option>
              <Option :value="'8'">{{ $t('连续8天未操作') }}</Option>
              <Option :value="'9'">{{ $t('连续9天未操作') }}</Option>
              <Option :value="'10'">{{ $t('连续10天未操作') }}</Option>
              <Option :value="'10-20'">{{ $t('连续10~20天未操作') }}</Option>
              <Option :value="'20-30'">{{ $t('连续20~30天未操作') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'userManage/UserList/add'" @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80">
        <FormItem label='会员类型' prop='user_type'>
          <Select v-model='windowAddItem.user_type' style='width:200px'>
            <!--            <Option :value="'0'" :key='0'>{{ $t('普通会员') }}</Option>-->
            <Option :value="'1'" :key='1'>{{ $t('代理帐号') }}</Option>
            <Option :value="'2'" :key='1'>{{ $t('测试帐号') }}</Option>
          </Select>
        </FormItem>
        <FormItem label='邀请码' prop='code'>
          <Input v-model='windowAddItem.code' :placeholder="$t('请输入邀请码(非必需)(测试帐号不要填写邀请码)')"></Input>
        </FormItem>
        <FormItem label='会员帐号' prop='username'>
          <Input v-model='windowAddItem.username' :placeholder="$t('请输入会员帐号')"></Input>
        </FormItem>
        <FormItem label='用户密码' prop='password'>
          <Input v-model='windowAddItem.password' :placeholder="$t('请输入用户密码')"></Input>
        </FormItem>
        <FormItem label='用户交易密码' prop='safe_password'>
          <Input v-model='windowAddItem.safe_password' :placeholder="$t('请输入用户交易密码')"></Input>
        </FormItem>
        <FormItem label='渠道' prop='channel'>
          <Input v-model='windowAddItem.channel' :placeholder="$t('渠道号(用于多条代理线合并统计),建议设置数字 1~9999任意')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <Modal v-model="windowResetPas.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowResetPasCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowResetPasItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowResetPasForm" :rules="windowResetPasValidate" :model="windowResetPasItem" :label-width="100">
        <FormItem label='重置登陆密码' prop='password'>
          <Input v-model='windowResetPasItem.password' :placeholder="$t('请输入重置登陆密码')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowResetPasCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowResetPasSubmit" :loading="windowResetPas.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <Modal v-model="windowResetSafePas.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowResetSafePasCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowResetSafePasItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowResetSafePasForm" :rules="windowResetSafePasValidate" :model="windowResetSafePasItem"
            :label-width="80">
        <FormItem label='重置安全密码' prop='safe_password'>
          <Input v-model='windowResetSafePasItem.safe_password' :placeholder="$t('请输入重置安全密码')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowResetSafePasCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowResetSafePasSubmit" :loading="windowResetSafePas.loading">{{ $t('确定') }}
        </Button>
      </div>
    </Modal>
    <Modal v-model="windowChangeLevel.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowChangeLevelCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowChangeLevelItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowChangeLevelForm" :rules="windowChangeLevelValidate" :model="windowChangeLevelItem"
            :label-width="80">
        <FormItem label='转至层级' prop='level'>
          <Select v-model='windowChangeLevelItem.level' style='width:200px'>
            <Option :value="'1'" :key='1'>{{ $t('第一层') }}</Option>
            <Option :value="'2'" :key='2'>{{ $t('第二层') }}</Option>
            <Option :value="'3'" :key='3'>{{ $t('第三层') }}</Option>
            <Option :value="'4'" :key='4'>{{ $t('第四层') }}</Option>
            <Option :value="'5'" :key='5'>{{ $t('第五层') }}</Option>
            <Option :value="'6'" :key='6'>{{ $t('第六层') }}</Option>
            <Option :value="'7'" :key='7'>{{ $t('第七层') }}</Option>
            <Option :value="'8'" :key='8'>{{ $t('第八层') }}</Option>
            <Option :value="'9'" :key='9'>{{ $t('第九层') }}</Option>
            <Option :value="'0'" :key='0'>{{ $t('黑名单层') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowChangeLevelCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowChangeLevelSubmit" :loading="windowChangeLevel.loading">{{ $t('确定') }}
        </Button>
      </div>
    </Modal>


    <Modal v-model="windowChangeGrade.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowChangeGradeCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowChangeGradeItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowChangeGradeForm" :model="windowChangeGradeItem"
            :label-width="80">
        <FormItem label='转至等级' prop='level'>
          <Select v-model='windowChangeGradeItem.grade' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('Free') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('VIP1') }}</Option>
            <Option :value="'2'" :key='2'>{{ $t('VIP2') }}</Option>
            <Option :value="'3'" :key='3'>{{ $t('VIP3') }}</Option>
            <Option :value="'4'" :key='4'>{{ $t('VIP4') }}</Option>
            <Option :value="'5'" :key='5'>{{ $t('VIP5') }}</Option>
            <Option :value="'6'" :key='6'>{{ $t('VIP6') }}</Option>

          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowChangeGradeCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowChangeGradeSubmit" :loading="windowChangeGrade.loading">{{ $t('确定') }}
        </Button>
      </div>
    </Modal>

    <Modal v-model="windowChangeProxy.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowChangeProxyCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowChangeProxyItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowChangeProxyForm" :rules="windowChangeProxyValidate" :model="windowChangeProxyItem"
            :label-width="80">
        <FormItem label='会员帐号' prop='username'>
          <Input v-model='windowChangeProxyItem.username' disabled :placeholder="$t('请输入会员帐号')"></Input>
        </FormItem>
        <FormItem label='当前代理' prop='proxyName'>
          <Input v-model='windowChangeProxyItem.proxyName' disabled :placeholder="$t('请输入当前代理')"></Input>
        </FormItem>
        <FormItem label='新代理帐号' prop='newProxyName'>
          <Input v-model='windowChangeProxyItem.newProxyName' :placeholder="$t('请输入新代理帐号')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowChangeProxyCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowChangeProxySubmit" :loading="windowChangeProxy.loading">{{ $t('确定') }}
        </Button>
      </div>
    </Modal>
    <Modal v-model="windowChangeToProxy.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowChangeToProxyCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowChangeToProxyItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowChangeToProxyForm" :rules="windowChangeToProxyValidate" :model="windowChangeToProxyItem"
            :label-width="80">
        <FormItem label='修改会员类型' prop='user_type'>
          <Select v-model='windowChangeToProxyItem.user_type' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('普通会员') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('代理会员') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowChangeToProxyCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowChangeToProxySubmit" :loading="windowChangeToProxy.loading">
          {{ $t('确定') }}
        </Button>
      </div>
    </Modal>
    <Modal v-model="windowLockAndunlock.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowLockAndunlockCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowLockAndunlockItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowLockAndunlockForm" :rules="windowLockAndunlockValidate" :model="windowLockAndunlockItem"
            :label-width="120">
        <FormItem label='修改会员状态' prop='is_lock'>
          <Select v-model='windowLockAndunlockItem.is_lock' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('正常') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('锁定') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowLockAndunlockCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowLockAndunlockSubmit" :loading="windowLockAndunlock.loading">
          {{ $t('确定') }}
        </Button>
      </div>
    </Modal>
    <Modal v-model="windowSetCanWithdraw.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowSetCanWithdrawCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowSetCanWithdrawItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowSetCanWithdrawForm" :rules="windowSetCanWithdrawValidate" :model="windowSetCanWithdrawItem"
            :label-width="80">
        <FormItem label='用户余额' prop='account_money'>
          <Input v-model='windowSetCanWithdrawItem.account_money' disabled :placeholder="$t('请输入用户余额')"></Input>
        </FormItem>
        <FormItem label='可提现额度' prop='canWithdrawMoney'>
          <Input v-model='windowSetCanWithdrawItem.canWithdrawMoney' :placeholder="$t('请输入可提现额度')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowSetCanWithdrawCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowSetCanWithdrawSubmit" :loading="windowSetCanWithdraw.loading">
          {{ $t('确定') }}
        </Button>
      </div>
    </Modal>
    <Modal v-model="windowSetRemark.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowSetRemarkCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowSetRemarkItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowSetRemarkForm" :rules="windowSetRemarkValidate" :model="windowSetRemarkItem" :label-width="120">
        <FormItem v-if="windowSetRemarkItem.isKefu==0" label='用户备注' prop='remark'>
          <Input v-model='windowSetRemarkItem.remark' :placeholder="$t('请输入用户备注')"></Input>
        </FormItem>
        <FormItem v-if="windowSetRemarkItem.isKefu==1" label='客服地址' prop='kefu'>
          <Input v-model='windowSetRemarkItem.kefu' :placeholder="$t('请输入客服地址')"></Input>
        </FormItem>

        <FormItem v-if="windowSetRemarkItem.isKefu==3"  label='会员过期日期' prop='on_day'>
          <DatePicker type="date" v-model='windowSetRemarkItem.vip_expire_time'
                      format="yyyy-MM-dd" @on-change='timeChange2'
                      :placeholder="$t('选择时间')" style="width: 200px">
          </DatePicker>
        </FormItem>

        <FormItem v-if="windowSetRemarkItem.isKefu==4" label='修改提现权限' prop='is_can_withdraw'>
          <Select v-model='windowSetRemarkItem.is_can_withdraw' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('无权限') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('允许提现') }}</Option>
          </Select>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button type="text" @click="windowSetRemarkCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowSetRemarkSubmit" :loading="windowSetRemark.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  resetPass,
  lock,
  changeLevel,
  changeRemark,
  changeGrade,
  add,
  addKefu,
  changeVipExpireTime,
  changeIsCanWithdraw
} from '@/api/userManage/UserList'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

const cateage = (vm, h, currentRow, index) => {
  return h('div', [
    h('Dropdown', {
      style: {
        marginBottom: '5px'
      }
    }, [
      h(
        'Button', {
          props: {
            type: 'success',
          }
        },
        [
          '管理选择',
          h('Icon', {
            props: {
              type: 'ios-arrow-down'
            }
          })
        ]
      ),
      h(
        'Dropdown-menu', {
          slot: 'list'
        },
        [
          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '用户提现卡管理', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '用户提现卡'),
          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '会员登陆日志', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '会员登录日志'),
          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {

                vm.windowResetPasItem.id = currentRow.id
                vm.windowResetPasItem.password = ''
                vm.windowResetPas.show = true

              }
            }
          }, '登录密码重置'),

          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowResetSafePasItem.id = currentRow.id
                vm.windowResetSafePasItem.safe_password = ''
                vm.windowResetSafePas.show = true

              }
            }
          }, '安全密码重置'),

          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowLockAndunlockItem.id = currentRow.id
                vm.windowLockAndunlockItem.is_lock = currentRow.is_lock.toString()
                vm.windowLockAndunlock.show = true
              }
            }
          }, '会员锁定/解锁'),
          // h('Dropdown-item', {
          //   props: {
          //     disabled: currentRow.UserType == 1 ? true : false
          //   },
          //   nativeOn: {
          //     click: () => {
          //       // if (currentRow.UserType == 1) return
          //       // vm.setpwdnumthree = index
          //       // vm.agency(index)
          //     }
          //   }
          // }, '转为代理'),
          // h('Dropdown-item', {
          //   nativeOn: {
          //     click: () => {
          //       vm.model.modelseven = true
          //       let params = {
          //         id: currentRow.id
          //       }
          //       vm.revampUser = currentRow
          //       revampOnline(params).then(response => {
          //         vm.topUserList = response.data.data
          //       })
          //     }
          //   }
          // }, '转代理线'),
          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowChangeLevelItem.id = currentRow.id
                vm.windowChangeLevelItem.level = currentRow.level.toString()
                vm.windowChangeLevel.show = true
              }
            }
          }, '修改会员层级'),
          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowChangeGradeItem.id = currentRow.id
                vm.windowChangeGradeItem.grade = currentRow.grade.toString()
                console.log(vm.windowChangeGradeItem)
                vm.windowChangeGrade.show = true
              }
            }
          }, '修改会员等级'),
          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowSetRemarkItem.id = currentRow.id
                vm.windowSetRemarkItem.remark = currentRow.remark
                vm.windowSetRemarkItem.isKefu = 0
                vm.windowSetRemark.show = true
              }
            }
          }, '修改会员备注'),
          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowSetRemarkItem.id = currentRow.id
                vm.windowSetRemarkItem.kefu = currentRow.kefu
                vm.windowSetRemarkItem.isKefu = 1
                vm.windowSetRemark.show = true
              }
            }
          }, '添加客服地址'),
          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowSetRemarkItem.id = currentRow.id
                vm.windowSetRemarkItem.vip_expire_time = currentRow.vip_expire_time
                vm.windowSetRemarkItem.isKefu = 3
                vm.windowSetRemark.show = true
              }
            }
          }, '修改过期时间'),
          h('Dropdown-item', {
            nativeOn: {
              click: () => {
                vm.windowSetRemarkItem.id = currentRow.id
                vm.windowSetRemarkItem.is_can_withdraw = currentRow.is_can_withdraw.toString()
                vm.windowSetRemarkItem.isKefu = 4
                vm.windowSetRemark.show = true
              }
            }
          }, '修改提现权限'),
        ]
      )
    ]),
    h('Dropdown', {
      style: {
        marginBottom: '5px'
      }
    }, [
      h(
        'Button', {
          props: {
            type: 'success'
          }
        },
        [
          '财务管理选择',
          h('Icon', {
            props: {
              type: 'ios-arrow-down'
            },
          })
        ]
      ),
      h(
        'Dropdown-menu', {
          slot: 'list'
        },
        [
          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '待处理充值', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '充值记录'),
          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '待处理提现', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '提现记录'),
          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '交易记录', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '交易记录'),

          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '人工充值', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '人工打款'),

          h('Dropdown-item', {
            nativeOn: {
              click: (name) => {
                vm.$router.push({
                  name: '人工提现', //是中文的
                  params: {
                    username: currentRow.username
                  }
                })
              }
            }
          }, '人工提现'),
        ]
      )
    ]),
    // h('Button',{
    //   props:{
    //     type:'success'
    //   },
    //   style:{
    //     marginBottom:"5px"
    //   },
    //   on:{
    //     click:() => {
    //       vm.$router.push({
    //         name:"打码量审核", //是中文的
    //         params:{
    //           username:currentRow.username
    //         }
    //       })
    //     }
    //   }
    // },'查询打码量')
  ],)

}
export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [
        {
          title: this.$t('ID'),
          key: 'id',
          minWidth: 15,
          align: 'center'
        }, {
          title: this.$t('用户信息'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('帐号') + ':' + params.row.username), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('类型') + ':' + params.row.user_type), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('层级') + ':' + params.row.level_name), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('等级') + ':' + params.row.grade_name),
              h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('是否可提现') + ':' + (params.row.is_can_withdraw==1?'是':'否' || ''))])
          }
        }, {
          title: this.$t('代理信息'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('代理级') + ':' + params.row.proxy_level), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('上级') + ':' + params.row.top_username), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('下级人数') + ':' + params.row.low_count),])
          }
        }, {
          title: this.$t('余额'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('余额') + ':' + params.row.account_money), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('余额宝') + ':' + params.row.yeb_all_money)])
          }
        }, {
          title: this.$t('盈亏'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('平台总盈亏') + ':' + params.row.ptTotalWin),])
          }
        }, {
          title: this.$t('存取款'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总充值') + ':' + params.row.all_recharge), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总提现') + ':' + params.row.all_withdraw)])
          }
        }, {
          title: this.$t('每日任务'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('任务派奖') + ':' + params.row.game_profit), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('任务返佣') + ':' + params.row.game_fan),])

          }
        }, {
          title: this.$t('余额宝'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('利息派送') + ':' + params.row.yeb_profit), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('转入') + ':' + params.row.yeb_to_yeb), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('转出') + ':' + params.row.yeb_to_account)])

          }
        }, {
          title: this.$t('VIP'),
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP消费总额') + ':' + params.row.game_buy_vip), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP押金返还') + ':' + params.row.game_back_vip), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP1次数') + ':' + params.row.game_buy_vip1_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP2次数') + ':' + params.row.game_buy_vip2_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP3次数') + ':' + params.row.game_buy_vip3_user)])

          }
        }, {
          title: this.$t('VIP'),
          align: 'center',
          minWidth: 90,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP4次数') + ':' + params.row.game_buy_vip4_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP5次数') + ':' + params.row.game_buy_vip5_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP6次数') + ':' + params.row.game_buy_vip6_user)])

          }
        }, {
          title: this.$t('赠送礼金'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('人工赠送') + ':' + params.row.rengong_send), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('活动赠送') + ':' + params.row.huodong_send), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('充值赠送') + ':' + params.row.recharge_send), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总赠送') + ':' + params.row.all_send),])
          }
        }, {
          title: this.$t('最后登陆信息'),
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('登陆IP') + ':' + params.row.last_login_ip), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('登陆地区') + ':' + params.row.last_login_address), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('登陆时间') + ':' + params.row.last_login_time), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('最后操作') + ':' + params.row.lastvisit),])
          }
        }, {
          title: this.$t('是否锁定 '),
          align: 'center',
          minWidth: 80,

          key: 'is_lock',
          render: (h, params) => {
            if (params.row.is_lock == 1) {
              return h('div', [
                h('span', {
                  props: {
                    type: 'error',
                  },
                  style: {
                    color: '#ed4014',
                    borderRadius: '11px',
                    border: '1px solid #ed4014',
                    display: 'block',
                    height: '25px',
                    width: '70%',
                    lineHeight: '25px',
                    margin: 'auto'
                  },
                }, this.$t(' 锁定')),

              ])
            } else {
              return h('div', [
                h('span', {
                  props: {
                    type: 'success',
                  },
                  style: {
                    color: '#19be6b',
                    borderRadius: '11px',
                    border: '1px solid #19be6b',
                    display: 'block',
                    height: '25px',
                    width: '70%',
                    lineHeight: '25px',
                    margin: 'auto'
                  },
                }, this.$t(' 正常 ')),
              ])
            }
          }
        }, {
          title: this.$t('其它信息'),
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            let vm = this
            return h('div',
              [
                //   h('p', {
                //   style: {
                //     textAlign: 'left',
                //     marginLeft: '5px'
                //   }
                // }, this.$t('手机号') + ':' + (params.row.mobile||'')),
                h('p', {
                  style: {
                    textAlign: 'left',
                    marginLeft: '5px'
                  }
                }, this.$t('注册') + ':' + params.row.register_time),
                h('p', {
                  style: {
                    textAlign: 'left',
                    marginLeft: '5px'
                  }
                }, this.$t('过期日期') + ':' + params.row.vip_expire_time),
                h('p', {
                  style: {
                    textAlign: 'left',
                    marginLeft: '5px'
                  }
                }, this.$t('客服地址') + ':' + (params.row.kefu || '')),
              h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('首充时间') + ':' + params.row.first_recharge_day), h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('渠道') + ':' + params.row.channel), h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('备注') + ':' + params.row.remark),])
          }
        }, {
          title: this.$t('会员管理'),
          key: 'admin',

          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [cateage(this, h, params.row, params.index)])
          }
        },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      }, windowResetPas: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowResetPasItem: { //弹窗数据绑定
        id: 0,
        password: ''
      },
      windowResetPasValidate: {//窗口校验规则
      }, windowResetSafePas: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowResetSafePasItem: { //弹窗数据绑定
        id: 0,
        safe_password: ''
      },
      windowResetSafePasValidate: {//窗口校验规则
      }, windowChangeLevel: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowChangeGrade: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowChangeLevelItem: { //弹窗数据绑定
        id: 0,
        level: ''
      },
      windowChangeGradeItem: { //弹窗数据绑定
        id: 0,
        grade: ''
      },
      windowChangeLevelValidate: {//窗口校验规则
      }, windowChangeProxy: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowChangeProxyItem: { //弹窗数据绑定
        id: 0
      },
      windowChangeProxyValidate: {//窗口校验规则
      }, windowChangeToProxy: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowChangeToProxyItem: { //弹窗数据绑定
        id: 0
      },
      windowChangeToProxyValidate: {//窗口校验规则
      }, windowLockAndunlock: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowLockAndunlockItem: { //弹窗数据绑定
        id: 0
      },
      windowLockAndunlockValidate: {//窗口校验规则
      }, windowSetCanWithdraw: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowSetCanWithdrawItem: { //弹窗数据绑定
        id: 0
      },
      windowSetCanWithdrawValidate: {//窗口校验规则
      }, windowSetRemark: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowSetRemarkItem: { //弹窗数据绑定
        id: 0,
        remark: '',
        is_can_withdraw:'0'
      },
      windowSetRemarkValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('userManage/UserList/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('userManage/UserList/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('userManage/UserList/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAdd.show = true
      //vm.windowAddEdit.show = true
    },
    timeChange2 (date) { //时间修改，自动计算尾部时间
      this.windowSetRemarkItem.vip_expire_time = date

    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    resetPass (isSafe, user_id, password) {
      let vm = this
      resetPass(isSafe, user_id, password).then(response => {
        vm.$Message.success(response.data.msg)
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          if (vm.windowAddItem.id === 0) {
            add(vm.windowAddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowAddCancel()
            }).catch(() => {
              vm.windowAdd.loading = false
            })
          } else {
            edit(vm.windowAddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowAddCancel()
            }).catch(() => {
              vm.windowAdd.loading = false
            })
          }
        }
      })
    }, windowResetPasCancel (data) {
      if (!data) {
        this.windowResetPasItem.id = 0
        this.$refs['windowResetPasForm'].resetFields()
        this.windowResetPas.show = false
        this.windowResetPas.loading = false
        this.windowResetPas.index = 0
      }
    }, windowResetPasSubmit () {
      let vm = this
      vm.resetPass(0, vm.windowResetPasItem.id, vm.windowResetPasItem.password)
      vm.windowResetPasCancel()

    }, windowResetSafePasCancel (data) {
      if (!data) {
        this.windowResetSafePasItem.id = 0
        this.$refs['windowResetSafePasForm'].resetFields()
        this.windowResetSafePas.show = false
        this.windowResetSafePas.loading = false
        this.windowResetSafePas.index = 0
      }
    }, windowResetSafePasSubmit () {
      let vm = this
      vm.resetPass(1, vm.windowResetSafePasItem.id, vm.windowResetSafePasItem.safe_password)
      vm.windowResetSafePasCancel()
    }, windowChangeLevelCancel (data) {
      if (!data) {
        this.windowChangeLevelItem.id = 0
        this.$refs['windowChangeLevelForm'].resetFields()
        this.windowChangeLevel.show = false
        this.windowChangeLevel.loading = false
        this.windowChangeLevel.index = 0
      }
    }, windowChangeLevelSubmit () {
      let vm = this
      changeLevel(vm.windowChangeLevelItem.id, vm.windowChangeLevelItem.level).then(response => {
        this.$Message.success(response.data.msg)
        vm.getList()
      })
      vm.windowChangeLevelCancel()
    }, windowChangeGradeCancel (data) {
      if (!data) {
        this.windowChangeGradeItem.id = 0
        this.$refs['windowChangeGradeForm'].resetFields()
        this.windowChangeGrade.show = false
        this.windowChangeGrade.loading = false
        this.windowChangeGrade.index = 0
      }
    }, windowChangeGradeSubmit () {
      let vm = this
      console.log(vm.windowChangeGradeItem)
      changeGrade(vm.windowChangeGradeItem.id, vm.windowChangeGradeItem.grade).then(response => {
        this.$Message.success(response.data.msg)
        vm.getList()
      })
      vm.windowChangeGradeCancel()
    }, windowChangeProxyCancel (data) {
      if (!data) {
        this.windowChangeProxyItem.id = 0
        this.$refs['windowChangeProxyForm'].resetFields()
        this.windowChangeProxy.show = false
        this.windowChangeProxy.loading = false
        this.windowChangeProxy.index = 0
      }
    }, windowChangeProxySubmit () {
      let vm = this
      vm.$refs['windowChangeProxyForm'].validate((valid) => {
        if (valid) {
          vm.windowChangeProxy.loading = true
          if (vm.windowChangeProxyItem.id === 0) {
            add(vm.windowChangeProxyItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowChangeProxyCancel()
            }).catch(() => {
              vm.windowChangeProxy.loading = false
            })
          } else {
            edit(vm.windowChangeProxyItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowChangeProxyCancel()
            }).catch(() => {
              vm.windowChangeProxy.loading = false
            })
          }
        }
      })
    }, windowChangeToProxyCancel (data) {
      if (!data) {
        this.windowChangeToProxyItem.id = 0
        this.$refs['windowChangeToProxyForm'].resetFields()
        this.windowChangeToProxy.show = false
        this.windowChangeToProxy.loading = false
        this.windowChangeToProxy.index = 0
      }
    }, windowChangeToProxySubmit () {
      let vm = this
      vm.$refs['windowChangeToProxyForm'].validate((valid) => {
        if (valid) {
          vm.windowChangeToProxy.loading = true
          if (vm.windowChangeToProxyItem.id === 0) {
            add(vm.windowChangeToProxyItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowChangeToProxyCancel()
            }).catch(() => {
              vm.windowChangeToProxy.loading = false
            })
          } else {
            edit(vm.windowChangeToProxyItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowChangeToProxyCancel()
            }).catch(() => {
              vm.windowChangeToProxy.loading = false
            })
          }
        }
      })
    }, windowLockAndunlockCancel (data) {
      if (!data) {
        this.windowLockAndunlockItem.id = 0
        this.$refs['windowLockAndunlockForm'].resetFields()
        this.windowLockAndunlock.show = false
        this.windowLockAndunlock.loading = false
        this.windowLockAndunlock.index = 0
      }
    }, windowLockAndunlockSubmit () {
      let vm = this
      lock(vm.windowLockAndunlockItem.id, vm.windowLockAndunlockItem.is_lock).then(response => {
        this.$Message.success(response.data.msg)
        vm.getList()
      })

      vm.windowLockAndunlockCancel()

    }, windowSetCanWithdrawCancel (data) {
      if (!data) {
        this.windowSetCanWithdrawItem.id = 0
        this.$refs['windowSetCanWithdrawForm'].resetFields()
        this.windowSetCanWithdraw.show = false
        this.windowSetCanWithdraw.loading = false
        this.windowSetCanWithdraw.index = 0
      }
    }, windowSetCanWithdrawSubmit () {
      let vm = this
      vm.$refs['windowSetCanWithdrawForm'].validate((valid) => {
        if (valid) {
          vm.windowSetCanWithdraw.loading = true
          if (vm.windowSetCanWithdrawItem.id === 0) {
            add(vm.windowSetCanWithdrawItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowSetCanWithdrawCancel()
            }).catch(() => {
              vm.windowSetCanWithdraw.loading = false
            })
          } else {
            edit(vm.windowSetCanWithdrawItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowSetCanWithdrawCancel()
            }).catch(() => {
              vm.windowSetCanWithdraw.loading = false
            })
          }
        }
      })
    }, windowSetRemarkCancel (data) {
      if (!data) {
        this.windowSetRemarkItem.id = 0
        this.$refs['windowSetRemarkForm'].resetFields()
        this.windowSetRemark.show = false
        this.windowSetRemark.loading = false
        this.windowSetRemark.index = 0
      }
    }, windowSetRemarkSubmit () {
      let vm = this
      if (vm.windowSetRemarkItem.isKefu==1) {
        addKefu(vm.windowSetRemarkItem.id, vm.windowSetRemarkItem.kefu).then(response => {
          this.$Message.success(response.data.msg)
          vm.getList()
        })
      } else if(vm.windowSetRemarkItem.isKefu==0) {
        changeRemark(vm.windowSetRemarkItem.id, vm.windowSetRemarkItem.remark).then(response => {
          this.$Message.success(response.data.msg)
          vm.getList()
        })
      }else if(vm.windowSetRemarkItem.isKefu==3){
        changeVipExpireTime(vm.windowSetRemarkItem.id, vm.windowSetRemarkItem.vip_expire_time).then(response => {
          this.$Message.success(response.data.msg)
          vm.getList()
        })
      }else if(vm.windowSetRemarkItem.isKefu==4){
        changeIsCanWithdraw(vm.windowSetRemarkItem.id, vm.windowSetRemarkItem.is_can_withdraw).then(response => {
          this.$Message.success(response.data.msg)
          vm.getList()
        })
      }

      vm.windowSetRemarkCancel()

    },
  }
}
</script>
